import {
    Component,
    computed,
    effect,
    ElementRef,
    inject,
    OnDestroy,
    Renderer2,
    Input,
    ViewChild
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../service/layout.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { AppModule } from '../../app.module';
import { UserRoleEnum } from '../../user-info';
import { IUserRole } from '../../user-role';
import {
    catchError,
    filter,
    take,
    takeWhile,
    withLatestFrom
} from 'rxjs/operators';
import { PinDialogComponent } from '../../auth';
import { Observable, of, ReplaySubject, throwError } from 'rxjs';
import {
    ErrorsSidenavComponent,
    getErrorAction
} from '../../shared/errors-sidenav';
import { CompanyAccessDialogComponent } from '../../auth/company-access-dialog/company-access-dialog.component';
import { select, Store } from '@ngrx/store';
import {
    AutoCompleteModule,
    DialogModule,
    DialogService,
    DrawerModule,
    EfaactPrimeNGModule,
    FloatLabelModule,
    PopoverModule,
    Process,
    SelectItem,
} from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { AppComponent } from '../../app.component';
import * as fromAuth from '../../auth';
import * as fromDataServices from '../../data-services';
import * as fromUser from '../../user-info';
import { environment } from '../../../environments/environment';
import * as fromRoot from '../../store';
import { FormsModule } from '@angular/forms';
import { ErrorsSidenavWrapperComponent } from './ef-errors-sidenav-wrapper';
import { UIRouterModule } from '@uirouter/angular';
import { SelectModule } from 'primeng/select';
import { AppConfigurator } from './app.configurator';

@Component({
    selector: '[app-menu-profile]',
    templateUrl: './app.menuprofile.html',
    styleUrls: ['./app.menuprofile.scss'],
    standalone: true,
    providers: [AppConfigurator],
    imports: [
        CommonModule,
        TooltipModule,
        ButtonModule,
        RouterModule,
        UIRouterModule,
        DialogModule,
        PopoverModule,
        FloatLabelModule,
        SelectModule,
        FormsModule,
        DrawerModule
    ],
    // template: `<button (click)="toggleMenu()" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
    //         <img src="/demo/images/avatar/amyelsner.png" alt="avatar" style="width: 32px; height: 32px;" />
    //         <span class="text-start">
    //             <strong>Amy Elsner</strong>
    //             <small>Webmaster</small>
    //         </span>
    //         <i class="layout-menu-profile-toggler pi pi-fw" [ngClass]="{ 'pi-angle-down': menuProfilePosition() === 'start' || isHorizontal(), 'pi-angle-up': menuProfilePosition() === 'end' && !isHorizontal() }"></i>
    //     </button>

    //     <ul *ngIf="menuProfileActive()" [@menu]="isHorizontal() ? 'overlay' : 'inline'">
    //         <li pTooltip="Settings" [tooltipDisabled]="isTooltipDisabled()" [routerLink]="['/profile/create']">
    //             <button [routerLink]="['/documentation']">
    //                 <i class="pi pi-cog pi-fw"></i>
    //                 <span>Settings</span>
    //             </button>
    //         </li>
    //         <li pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled()">
    //             <button [routerLink]="['/documentation']">
    //                 <i class="pi pi-file-o pi-fw"></i>
    //                 <span>Profile</span>
    //             </button>
    //         </li>
    //         <li pTooltip="Support" [tooltipDisabled]="isTooltipDisabled()">
    //             <button [routerLink]="['/documentation']">
    //                 <i class="pi pi-compass pi-fw"></i>
    //                 <span>Support</span>
    //             </button>
    //         </li>
    //         <li pTooltip="Logout" [tooltipDisabled]="isTooltipDisabled()" [routerLink]="['/auth/login2']">
    //             <button class="p-link">
    //                 <i class="pi pi-power-off pi-fw"></i>
    //                 <span>Logout</span>
    //             </button>
    //         </li>
    //     </ul>`,
    animations: [
        trigger('menu', [
            transition('void => inline', [
                style({ height: 0 }),
                animate(
                    '400ms cubic-bezier(0.86, 0, 0.07, 1)',
                    style({ opacity: 1, height: '*' })
                )
            ]),
            transition('inline => void', [
                animate(
                    '400ms cubic-bezier(0.86, 0, 0.07, 1)',
                    style({ opacity: 0, height: '0' })
                )
            ]),
            transition('void => overlay', [
                style({ opacity: 0, transform: 'scaleY(0.8)' }),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)')
            ]),
            transition('overlay => void', [
                animate('.1s linear', style({ opacity: 0 }))
            ])
        ]),
        trigger('profilePanel', [
            state(
                'hidden',
                style({
                    opacity: 0,
                    transform: 'translateX(0%)',
                    display: 'none'
                })
            ),
            state(
                'visible',
                style({
                    opacity: 1,
                    transform: 'translateX(0)',
                    display: 'block'
                })
            ),
            transition('hidden => visible', [
                style({
                    display: 'block',
                    opacity: 0,
                    transform: 'translateX(0%)'
                }),
                animate(
                    '200ms ease-out',
                    style({ opacity: 1, transform: 'translateX(0)' })
                )
            ]),
            transition('visible => hidden', [
                animate(
                    '200ms ease-in',
                    style({ opacity: 0, transform: 'translateX(0%)' })
                )
            ])
        ])
    ],
    host: {
        class: 'layout-menu-profile'
    }
})
export class AppMenuProfile implements OnDestroy {
    settingsToggle = false;
    profileToggle = false;
    layoutService = inject(LayoutService);

    //renderer = inject(Renderer2);

    el = inject(ElementRef);

    isHorizontal = computed(
        () =>
            this.layoutService.isHorizontal() && this.layoutService.isDesktop()
    );

    menuProfileActive = computed(
        () => this.layoutService.layoutState().menuProfileActive
    );

    menuProfilePosition = computed(
        () => this.layoutService.layoutConfig().menuProfilePosition
    );

    isTooltipDisabled = computed(() => !this.layoutService.isSlim());

    subscription!: Subscription;

    outsideClickListener: any;

    @ViewChild('profilePanel') profilePanel!: ElementRef;

    constructor(
        public ele: ElementRef,
        public app: AppComponent,
        private store: Store<fromUser.State>,
        public entityServices: EntityServices,
        private log: LoggingService,
        private dialogService: DialogService,
        private renderer: Renderer2,
        private appconfigurator: AppConfigurator
    ) {
        this.companyAccessDataService =
            entityServices.getEntityCollectionService<fromDataServices.CompanyAccess.CompanyAccessModel>(
                fromDataServices.CompanyAccess.entityName
            );
        this.companyAccessDataService.clearCache();
        this.subscription = this.layoutService.overlayOpen$.subscribe(() => {
            if (this.isHorizontal() && this.menuProfileActive()) {
                this.layoutService.layoutState.update(value => ({
                    ...value,
                    menuProfileActive: false
                }));
            }
        });

        effect(() => {
            if (
                this.isHorizontal() &&
                this.menuProfileActive() &&
                !this.outsideClickListener
            ) {
                this.bindOutsideClickListener();
            }

            if (!this.menuProfileActive() && this.isHorizontal()) {
                this.unbindOutsideClickListener();
            }
        });
    }

    toggleTheme(): void {
        this.layoutService.updateDarkTheme(!this.layoutService.isDarkTheme());
    }

    openMySettings(routename) {
        this.app.goto({
            RouteName: routename
        } as Process);
    }

    bindOutsideClickListener() {
        if (this.isHorizontal()) {
            this.outsideClickListener = this.renderer.listen(
                document,
                'click',
                (event: MouseEvent) => {
                    if (this.menuProfileActive()) {
                        const isOutsideClicked = !(
                            this.el.nativeElement.isSameNode(event.target) ||
                            this.el.nativeElement.contains(event.target)
                        );
                        if (isOutsideClicked) {
                            this.layoutService.layoutState.update(value => ({
                                ...value,
                                menuProfileActive: false
                            }));
                        }
                    }
                }
            );
        }
    }

    unbindOutsideClickListener() {
        if (this.outsideClickListener) {
            this.outsideClickListener();
            this.outsideClickListener = null;
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.unbindOutsideClickListener();
        this.componentActive = false;
    }

    toggleMenu() {
        this.layoutService.onMenuProfileToggle();
    }
    toggleSlimMenu() {
        this.layoutService.onMenuTypeToggle('slim');
        this.profilePanel.nativeElement.style.left = '80px';
    }
    toggleStaticMenu() {
        this.layoutService.onMenuTypeToggle('static');
        this.profilePanel.nativeElement.style.left = '247px';
        this.profilePanel.nativeElement.style.zIndex = 999999;
    }
    toggleRevealMenu() {
        this.layoutService.onMenuTypeToggle('reveal');
    }
    toggleMenuType() {
        if (this.layoutService.layoutConfig().menuMode === 'slim') {
            this.toggleRevealMenu();
        } else {
            this.toggleSlimMenu();
        }
    }

    activeItem!: number;

    get mobileTopbarActive(): boolean {
        return this.layoutService.layoutState().topbarMenuActive;
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    onConfigSidebarToggle() {
        this.layoutService.showConfigSidebar();
    }

    private componentActive = true;
    // public mainProcess$: Observable<Process[]>;
    auth$: Observable<fromAuth.State>;
    private switchCompanySubject = new ReplaySubject<string>(1);
    @Input() userInfo: fromUser.IUserInfo;
    @Input() user: fromUser.IUserAccess;
    @Input() roles: IUserRole[];
    private companyAccessDataService: EntityCollectionService<fromDataServices.CompanyAccess.CompanyAccessModel>;
    @Input() processes: Process[];
    @Input() processTitles: string[];

    showAbout = false;
    public environment = environment;
    public version$: Observable<string>;
    eFAACTApiVersion: string;
    eFAACTVersion = `${environment.version}-${environment.environment}`;
    softwareLicenseAgreementLink =
        'https://www.efaactcentral.com/licensing/eFAACTHostedLicenseAgreement.htm';

    selectedProcess: Process;

    rolesSelectItem: SelectItem[];
    selectedRole: IUserRole;

    primaryColorSelectItem: SelectItem[];
    bluePallette = this.appconfigurator.primaryColors.find(x => x.name === 'blue');
    selectedPrimaryColor = this.bluePallette.palette;

    ngOnInit() {
        this.rolesSelectItem = this.roles.map(role => ({
            label: role.GroupName,
            value: role.RoleGroupID
        }));
        // this.primaryColorSelectItem = this.appconfigurator.primaryColors.map(
        //     color => ({
        //         label: color.name,
        //         value: color.palette
        //     })
        // );
        // this.mainProcess$ = this.store.pipe(
        //     select(fromUser.getUserProcessesMain),
        //     map(processes => processes.filter(p => p.displayinmenu))
        // );

        this.auth$ = this.store.pipe(select(fromAuth.getAuth));
        this.setupSubscriptions();
    }
    primaryColorChanged(event) {
        let primaryColor = this.appconfigurator.primaryColors.find(x => x.palette === this.selectedPrimaryColor);
        this.appconfigurator.updateColors(event, 'primary', primaryColor);
    }
    roleChanged(event) {
        this.store.dispatch(
            new fromUser.SetUserInfo({
                ...this.userInfo,
                DefaultRoleGroupID: event.value
            })
        );
    }
    setupSubscriptions() {
        setTimeout(() => {
            this.version$ = this.store.pipe(
                select(fromRoot.Version.selectVersion)
            );
            this.version$.pipe(take(2)).subscribe(v => {
                this.eFAACTApiVersion = v;
            });
        }, 1000);
        this.companyAccessDataService.entities$
            .pipe(
                takeWhile(() => this.componentActive),
                filter(x => !!x && x.length > 0),
                withLatestFrom(this.auth$)
            )
            .subscribe(([companyAccess, auth]) => {
                this.log.verbose({
                    type: 'AppTopBarComponent:companyAccessDataService:entities$',
                    companyAccess
                });
                this.dialogService
                    .open(CompanyAccessDialogComponent, {
                        header: 'Select Company Access',
                        closable: false,
                        closeOnEscape: false,
                        showHeader: false,
                        modal: true,
                        data: {
                            userInfo: this.userInfo,
                            companies: companyAccess
                        }
                    })
                    .onClose.pipe(take(1))
                    .subscribe(data => {
                        this.log.verbose({
                            type: 'AppTopBarComponent:CompanyAccessDialogComponent:afterClosed',
                            data
                        });
                        const company = companyAccess.find(
                            x => x.id === data.company
                        );
                        this.log.verbose({
                            type: 'AppTopBarComponent:CompanyAccessDialogComponent:afterClosed',
                            company
                        });
                        this.companyAccessDataService.clearCache();
                        this.companyAccessDataService
                            .getWithQuery({
                                CustomerID: company.CustomerID.toString(),
                                contactemail: company.contactemail
                            })
                            .pipe(
                                take(1),
                                catchError(err => {
                                    this.log.error(err);
                                    throwError(err);
                                    return of(getErrorAction(err));
                                })
                            )
                            .subscribe(q => {
                                this.log.verbose({
                                    type: 'AppTopBarComponent:companyAccessDataService:getWithQuery',
                                    q
                                });
                                this.store.dispatch(
                                    new fromAuth.RememberMe({
                                        rememberMe: auth.rememberMe,
                                        username: null,
                                        pin: company.CustomerID.toString()
                                    })
                                );
                                this.store.dispatch(new fromAuth.Logout());
                            });
                    });
            });
        this.switchCompanySubject
            .pipe(
                takeWhile(() => this.componentActive),
                withLatestFrom(this.auth$)
            )
            .subscribe(([, auth]) => {
                this.log.verbose({
                    type: 'AppTopBarComponent:switchCompanySubject'
                });
                this.dialogService
                    .open(PinDialogComponent, {
                        header: 'Enter main customer ID/PIN',
                        closable: false,
                        closeOnEscape: false,
                        showHeader: false,
                        modal: true,
                        data: {
                            userInfo: this.userInfo
                            // pin: auth.pin
                        }
                    })
                    .onClose.pipe(take(1))
                    .subscribe(data => {
                        this.log.verbose({
                            type: 'AppTopBarComponent:switchCompanySubject:afterClosed',
                            data
                        });
                        if (!!data && !!data.pin) {
                            this.companyAccessDataService.getWithQuery({
                                CustomerID: data.pin
                            });
                        }
                    });
            });
    }
    openAbout() {
        this.showAbout = true;
    }
    openHelpDesk() {
        if (this.user) {
            if (
                this.user.UserProcessesMain &&
                this.user.UserProcessesMain.length > 0
            ) {
                const helpdeskProcess = this.user.UserProcessesMain.find(
                    x => x.ProcessID == 134
                );
                const helpdeskLink = helpdeskProcess.UrlDemo;
                window.open(helpdeskLink, '_blank');
            }
        }
    }
    openUserManual() {
        window.open(
            'https://www.efaactcentral.com/eFAACTUserManual/index.htm?',
            '_blank'
        );
    }
    openCompanyCalendar() {}
    roleName() {
        const role = this.roles.find(
            x => x.RoleGroupID === this.userInfo.DefaultRoleGroupID
        );
        return role ? role.GroupName : 'No Role';
    }
    roleChosen(roleID: number) {
        this.store.dispatch(
            new fromUser.SetUserInfo({
                ...this.userInfo,
                DefaultRoleGroupID: roleID
            })
        );
    }
    switchCompany() {
        this.log.verbose({ type: 'AppTopBarComponent:switchCompany' });
        this.switchCompanySubject.next();
    }
    isAdmin = (roles: IUserRole[]): boolean =>
        roles &&
        !!roles.find(x => x.RoleGroupID === UserRoleEnum.Administrator);

    isSupervisor = (roles: IUserRole[]): boolean =>
        roles && !!roles.find(x => x.RoleGroupID === UserRoleEnum.Supervisor);

    isTaskManager = (roles: IUserRole[]): boolean =>
        roles && !!roles.find(x => x.RoleGroupID === UserRoleEnum.TaskManager);

    isUser = (roles: IUserRole[]): boolean =>
        roles && !!roles.find(x => x.RoleGroupID === UserRoleEnum.User);

    filterProcessFromSearch($event) {
        this.processTitles = [];
        // const filteredProcesses = this.processes.filter(x =>
        //     x.ProcessTitle.toLowerCase().includes($event.query.toLowerCase()) ||
        //     x.ProcessDesc != null
        //         ? x.ProcessDesc.toLowerCase().includes(
        //               $event.query.toLowerCase()
        //           )
        //         : x.ProcessTitle.toLowerCase().includes(
        //               $event.query.toLowerCase()
        //           )
        // );

        const filteredProcesses = this.processes.filter(process => {
            if (process.ProcessDesc != null) {
                return (
                    process.ProcessDesc.toLowerCase().includes(
                        $event.query.toLowerCase()
                    ) ||
                    process.ProcessTitle.toLowerCase().includes(
                        $event.query.toLowerCase()
                    )
                );
            } else {
                return process.ProcessTitle.toLowerCase().includes(
                    $event.query.toLowerCase()
                );
            }
        });

        filteredProcesses.forEach(x => {
            this.processTitles.push(x.ProcessTitle);
        });
        this.log.verbose('text from search: ' + $event.query);
    }
    gotoProcessFromSearch(value) {
        this.log.verbose('selected process from search: ' + value);
        const process = this.processes.find(x => x.ProcessTitle == value);
        this.app.goto(process);
    }

    get isSlim() {
        return this.layoutService.isSlim();
    }
}
